// FILE: components/explore/sections/PathsSection.tsx
"use client";

import ExplorePathCard from "@/components/cards/ExplorePathCard";
import { memo } from "react";
import type { PathItem } from "../_shared/types";

interface Props {
  items: PathItem[];
  loading?: boolean;
}

function PathSkeleton() {
  return (
    <div className="bg-white border border-border rounded-2xl shadow-card overflow-hidden">
      <div className="h-32 bg-gradient-to-br from-slate-100 to-slate-200 animate-pulse" />
      <div className="p-4 flex flex-col gap-2">
        <div className="flex gap-1.5">
          <div className="h-4 w-16 bg-slate-100 rounded-full animate-pulse" />
          <div className="h-4 w-12 bg-slate-100 rounded-full animate-pulse" />
        </div>
        <div className="h-5 w-3/4 bg-slate-100 rounded animate-pulse" />
        <div className="h-3.5 w-1/2 bg-slate-100 rounded animate-pulse" />
        <div className="flex items-center justify-between pt-3 border-t border-slate-100 mt-1">
          <div className="h-5 w-16 bg-slate-100 rounded animate-pulse" />
          <div className="h-8 w-20 bg-slate-100 rounded-full animate-pulse" />
        </div>
      </div>
    </div>
  );
}

function PathsSectionImpl({ items, loading }: Props) {
  if (loading && items.length === 0) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {[1, 2, 3, 4, 5, 6].map((i) => <PathSkeleton key={i} />)}
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div className="text-center py-12 text-[13px] text-muted-foreground">
        Chưa có lộ trình nào
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {items.map((item) => (
        <ExplorePathCard key={item.id} {...item} />
      ))}
    </div>
  );
}

export const PathsSection = memo(PathsSectionImpl);